import React from"react";
import { useNavigate } from"react-router-dom";

const TechCard = ({ title, description, image, practiceLink, completedLevels = 0 }) => {
 const navigate = useNavigate();

 const [imgSrc, setImgSrc] = React.useState(image || "/common image.avif");

  const generateSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[()]/g, '')
      .replace(/\./g, '')
      .replace(/\+/g, 'plus')
      .replace(/\//g, '-')
      .replace(/--+/g, '-')
      .trim();
  };

  return (
    <div className="bg-white border-2 border-primary/10 rounded-[24px] shadow-xl p-6 w-full sm:w-80 hover:border-primary hover:shadow-primary/20 transition-all duration-300 group relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-0 right-0 w-24 h-24 bg-primary/5 rounded-full blur-2xl -mr-12 -mt-12 group-hover:bg-primary/10 transition-all"></div>
      <div className="absolute bottom-0 left-0 w-16 h-16 bg-accent/5 rounded-full blur-xl -ml-8 -mb-8 group-hover:bg-accent/10 transition-all"></div>
      
      <div className="flex items-center space-x-4 mb-6 relative z-10">
        <div className="w-14 h-14 rounded-2xl bg-bgMain flex items-center justify-center border border-primary/10 shadow-inner p-2 group-hover:border-primary/50 transition-all">
          <img
            src={imgSrc}
            alt={title}
            className="w-full h-full object-contain"
            onError={() => setImgSrc("/common image.avif")}
          />
        </div>
        <div className="flex-1">
          <h3 className="text-midnight text-xl font-bold group-hover:text-primary transition-colors leading-tight">{title}</h3>
          <div className="flex items-center gap-2 mt-1">
            <span className="w-1.5 h-1.5 rounded-full bg-accent"></span>
            <p className="text-muted text-[10px] font-black uppercase tracking-widest">{description}</p>
          </div>
        </div>
      </div>

      <div className="flex justify-between items-center relative z-10">
        <div className="text-[10px] font-black text-muted uppercase tracking-tighter">
          {completedLevels > 0 ? (
            <span className="text-primary flex items-center gap-1">
              <span className="text-sm">✓</span> {completedLevels} Levels Done
            </span>
          ) : (
            <span>Not Started</span>
          )}
        </div>
        <button
          className="bg-gradient-to-r from-primary to-secondary text-white px-6 py-2.5 rounded-xl text-xs font-black uppercase tracking-widest shadow-lg shadow-primary/20 hover:scale-105 active:scale-95 transition-all"
          onClick={() => navigate(`/practice/${generateSlug(title)}`)}
        >
          Start
        </button>
      </div>
 </div>
 );
};

export default TechCard;




